import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { IEMRPatient } from './types';
import { useState } from 'react';

export enum emrType {
  pointClick = 'pointclick',
  epic = 'epic',
  yardi = 'yardi'
}

export interface IPointClickSearchParams {
  patientName: string
}

export interface IEpicSearchParams {
  family?: string;
  given?: string;
  legalSex?: string;
  birthDate?: string;
  state?: string;
  telecom?: string;
  identifier?: string;
}

export interface IEMRService {
  EMRPatientsList: IEMRPatient[] | undefined;
  state: {
    isLoading: boolean;
    isError: boolean;
    error: unknown;
    isRefetching: boolean;
  };
  importEMRPatient: (patientId: number) => Promise<string>;

  updateSearchParams: (params: IPointClickSearchParams | IEpicSearchParams) => void;
  searchParams: IPointClickSearchParams | IEpicSearchParams | undefined;
}


export default function useEMRPatientsService(emr: emrType):IEMRService {
  const [searchParams, setSearchParams] = useState<IPointClickSearchParams | IEpicSearchParams>();
  const { data, isLoading, isError, error, isRefetching } = useQuery<{
    result: IEMRPatient[];
  }>({
    queryKey: ['camel', emr, 'list_patients', searchParams],
    enabled: !!searchParams,
    retry: false
  });

  const importEMRPatientAction = useMutation({
    mutationFn: async (patientId: number) => {
      const result = await axios.post<{ patientUuid: string }>(
        `/api/camel/${emr}/import_patient/`,
        {
          patientId,
        }
      );

      return result?.data?.patientUuid ?? '';
    },
  });

  return {
    EMRPatientsList: data?.result,
    state: {
      isLoading: !!searchParams && isLoading,
      isError,
      error,
      isRefetching,
    },
    importEMRPatient: importEMRPatientAction.mutateAsync,
    updateSearchParams: (params: IPointClickSearchParams | IEpicSearchParams) => {
      setSearchParams(params);
    },
    searchParams
  };
}
